import { createFileRoute } from '@tanstack/react-router';
import { RentalContractsCard } from './-components/RentalContractsCard';

export const Route = createFileRoute('/_auth/dashboard/_layout/rental-contracts')({
  component: RouteComponent,
  context: () => {
    return {
      getBreadcrumbData: () => ({
        id: null,
        translationKey: null,
      }),
    };
  },
  head: () => {
    return {
      meta: [
        {
          title: 'Rental Contracts - OPAZ E-Service Portal',
        },
      ],
    };
  },
});

function RouteComponent() {
  return <RentalContractsCard />;
}
